<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="'general.investmentQualification'"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <div class="scrollbar inexp-desc my-3 p-3">
    {{
      "registrationWizard.investorRatingModal.inexperienced.inexperiencedDescription"
        | translate
    }}
  </div>
  <div class="row flex-between-center">
    <div class="col-auto my-2">
      <div class="form-check mb-0">
        <input
          class="form-check-input"
          type="checkbox"
          id="startTest"
          [(ngModel)]="startTest"
        /><label class="form-check-label mb-0" for="startTest">{{
          "registrationWizard.investorRatingModal.inexperienced.understoodAndContinue"
            | translate
        }}</label>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-falcon-default btn-sm me-3"
    type="button"
    (click)="handleSecondaryAction()"
  >
    {{ "general.no" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="submit"
    (click)="handlePrimaryAction()"
  >
    {{ "general.yes" | translate
    }}<span class="ms-2" data-fa-transform="shrink-3"> </span>
  </button>
</ng-template>
